'use client'

import { Factory } from '@/app/[locale]/(landing-page)/supplier/_components/supplier-data'
import { Card, CardContent } from '@/components/ui/card'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import { ImageWithFallback as Image } from '@/components/common/image-with-fallback'

interface InfoPanelProps {
  factory: Factory
}

export function InfoPanel({ factory }: InfoPanelProps) {
  const t = useTranslations('landing_supplier')

  const infoItems = [
    { label: t('factories.company_name'), value: t(`${factory.i18nKey}.name`) },
    {
      label: t('factories.employees'),
      value: factory.stats?.employees,
    },
    {
      label: t('factories.production_capacity'),
      value: factory.stats?.productsKey ? t(factory.stats.productsKey) : '',
    },
  ].filter((item) => item.value) // Filter out items with no value

  return (
    <Card className='h-full overflow-hidden rounded-3xl border-none bg-[linear-gradient(212.5deg,#1A1A1A,#333333)] text-white shadow-lg'>
      <CardContent className='relative p-6 md:px-10 md:py-10 2xl:py-20'>
        <div className='relative z-10'>
          {infoItems.map((item, index) => (
            <div key={index} className={index !== 0 ? 'mt-6' : ''}>
              <p className='text-base text-white md:text-lg'>{item.label}</p>
              <p className='mt-1 font-criteria text-lg font-bold md:text-xl 2xl:text-2xl'>
                {item.value}
              </p>
            </div>
          ))}
        </div>
        <div className='absolute bottom-0 left-0 z-0'>
          <Image
            src={ImageHelper.getImageUrl('/image/August2025/mceclip7_98.png')}
            alt='Factory background'
            width={350}
            height={50}
            className='h-auto object-contain opacity-50'
          />
        </div>
      </CardContent>
    </Card>
  )
}
